export const formatTime = (ts) =>
  new Date(ts).toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
  });

export const getInitials = (name = "") =>
  name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);

export const generateTxId = () =>
  `TX-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`;

export const formatExpiryDate = (dateStr) => {
  const [y, m, d] = dateStr.split('-');
  return `${parseInt(m)}/${parseInt(d)}/${y}`;
};
